import React from 'react'
import AppBar from '@material-ui/core/AppBar'
import Toolbar from '@material-ui/core/Toolbar'
import Button from '@material-ui/core/Button'
import Container from '@material-ui/core/Container'
import Paper from '@material-ui/core/Paper'
import Box from '@material-ui/core/Box'
import Typography from '@material-ui/core/Typography'
import Link from '@material-ui/core/Link'
import Table from '@material-ui/core/Table'
import TableHead from '@material-ui/core/TableHead'
import TableBody from '@material-ui/core/TableBody'
import TableRow from '@material-ui/core/TableRow'
import TableCell from '@material-ui/core/TableCell'
import { withStyles } from '@material-ui/core/styles'
import LogoWhite from '../landpage/images/logo-white.png'

const styles = theme => ({
    page: {
        backgroundColor: '#f0f2f4',
        minHeight: '100vh',
        paddingBottom: theme.spacing(8),
    },
    appBar: {
        backgroundColor: theme.palette.primary.main,
    },
    toolbar: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
    },
    logoImg: {
        height: 34,
    },
    backButton: {
        color: '#fff',
        borderColor: 'rgba(255,255,255,0.6)',
    },
    hero: {
        backgroundColor: theme.palette.primary.main,
        color: '#fff',
        padding: theme.spacing(7, 3, 9, 3),
        textAlign: 'center',
    },
    heroSubtitle: {
        color: 'rgba(255,255,255,0.8)',
        maxWidth: 620,
        margin: '0.75rem auto 0 auto',
    },
    updatedBadge: {
        display: 'inline-block',
        marginTop: theme.spacing(2.5),
        padding: '5px 14px',
        backgroundColor: theme.palette.secondary.main,
        color: '#fff',
        fontSize: '0.72rem',
        fontWeight: 700,
        letterSpacing: '0.06em',
        textTransform: 'uppercase',
    },
    contentWrap: {
        marginTop: -theme.spacing(5),
    },
    paper: {
        padding: theme.spacing(3),
        [theme.breakpoints.up('sm')]: {
            padding: theme.spacing(6),
        },
    },
    intro: {
        color: 'rgba(0,0,0,0.72)',
        lineHeight: 1.7,
        marginBottom: theme.spacing(1),
    },
    divider: {
        height: 3,
        width: 56,
        backgroundColor: theme.palette.secondary.main,
        margin: theme.spacing(3, 0, 4, 0),
    },
    sectionHeading: {
        display: 'flex',
        alignItems: 'center',
        marginTop: theme.spacing(5),
        marginBottom: theme.spacing(2.5),
    },
    sectionBadge: {
        minWidth: 34,
        height: 34,
        lineHeight: '34px',
        textAlign: 'center',
        backgroundColor: theme.palette.primary.main,
        color: '#fff',
        fontWeight: 700,
        fontSize: '0.95rem',
        marginRight: theme.spacing(2),
        flexShrink: 0,
    },
    sectionTitle: {
        fontWeight: 700,
    },
    subHeading: {
        fontWeight: 700,
        color: theme.palette.primary.main,
        marginTop: theme.spacing(3.5),
        marginBottom: theme.spacing(1),
    },
    paragraph: {
        lineHeight: 1.75,
        color: 'rgba(0,0,0,0.75)',
        marginBottom: theme.spacing(2),
    },
    calloutBlock: {
        backgroundColor: 'rgba(14, 74, 100, 0.045)',
        borderLeft: `4px solid ${theme.palette.primary.main}`,
        padding: theme.spacing(2.5, 3),
        marginBottom: theme.spacing(3),
    },
    list: {
        paddingLeft: 0,
        listStyle: 'none',
        marginTop: 0,
        marginBottom: theme.spacing(2),
    },
    listItem: {
        display: 'flex',
        alignItems: 'flex-start',
        lineHeight: 1.7,
        color: 'rgba(0,0,0,0.75)',
        marginBottom: theme.spacing(1),
    },
    bullet: {
        width: 6,
        height: 6,
        marginTop: 9,
        marginRight: theme.spacing(1.5),
        backgroundColor: theme.palette.secondary.main,
        flexShrink: 0,
    },
    tableWrap: {
        overflowX: 'auto',
        marginBottom: theme.spacing(3),
    },
    tableHeadCell: {
        fontWeight: 700,
        backgroundColor: 'rgba(14, 74, 100, 0.06)',
    },
    footer: {
        backgroundColor: theme.palette.primary.main,
        color: 'rgba(255,255,255,0.85)',
        textAlign: 'center',
        padding: theme.spacing(4, 2),
        marginTop: theme.spacing(6),
    },
    footerBack: {
        display: 'inline-block',
        marginTop: theme.spacing(2),
        color: '#fff',
        fontWeight: 600,
    },
})

class PrivacyPolicyPage extends React.Component {

    componentDidMount () {
        document.title = 'Política de Privacidade | MOB Inspeção'
    }

    renderSection = (number, title) => {
        const { classes } = this.props
        return (
            <Box className={classes.sectionHeading}>
                <div className={classes.sectionBadge}>{number}</div>
                <Typography variant="h6" className={classes.sectionTitle}>{title}</Typography>
            </Box>
        )
    }

    renderList = items => {
        const { classes } = this.props
        return (
            <ul className={classes.list}>
                {items.map((item, index) => (
                    <li key={index} className={classes.listItem}>
                        <span className={classes.bullet} />
                        <span>{item}</span>
                    </li>
                ))}
            </ul>
        )
    }

    renderCookieTable = (columns, rows) => {
        const { classes } = this.props
        return (
            <div className={classes.tableWrap}>
                <Table size="small">
                    <TableHead>
                        <TableRow>
                            {columns.map(col => (
                                <TableCell key={col} className={classes.tableHeadCell}>{col}</TableCell>
                            ))}
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {rows.map((row, index) => (
                            <TableRow key={index}>
                                {row.map((cell, cellIndex) => (
                                    <TableCell key={cellIndex}>{cell}</TableCell>
                                ))}
                            </TableRow>
                        ))}
                    </TableBody>
                </Table>
            </div>
        )
    }

    render () {
        const { classes } = this.props

        return (
            <div className={classes.page}>
                <AppBar position="static" elevation={0} className={classes.appBar}>
                    <Toolbar className={classes.toolbar}>
                        <img alt="MOB Inspeção" src={LogoWhite} className={classes.logoImg} />
                        <Button href="#/" variant="outlined" className={classes.backButton}>
                            Voltar para o login
                        </Button>
                    </Toolbar>
                </AppBar>

                <Box className={classes.hero}>
                    <Typography variant="h4" style={{ fontWeight: 700 }}>Política de Privacidade</Typography>
                    <Typography variant="body1" className={classes.heroSubtitle}>
                        Como tratamos, utilizamos e protegemos os seus dados pessoais.
                    </Typography>
                    <span className={classes.updatedBadge}>Última atualização: 02 de julho de 2026</span>
                </Box>

                <Container maxWidth="md" className={classes.contentWrap}>
                    <Paper elevation={3} className={classes.paper}>

                        <Typography className={classes.intro}>
                            A Bunzl do Brasil (“Bunzl”) deseja manter uma relação de confiança e transparência com todos aqueles com quem se relaciona. Nós agradecemos a confiança que você demonstra em nós quando compartilha seus Dados Pessoais conosco, e levamos a segurança das suas informações a sério.
                        </Typography>
                        <Typography className={classes.intro}>
                            Para honrar esse compromisso, elaboramos este Aviso de Privacidade (ou simplesmente “Aviso”) que contém informações sobre como tratamos os seus dados pessoais: quais dados nós tratamos, por qual(is) motivo(s), e com quem os compartilhamos. Além disso, você encontrará nesse Aviso quais são os seus direitos relativos a essas informações e como exercê-los junto à Bunzl.
                        </Typography>
                        <Typography className={classes.intro}>
                            É importante que, periodicamente, você releia estas informações, uma vez que este Aviso de Privacidade poderá sofrer alterações.
                        </Typography>
                        <Typography className={classes.intro}>
                            Se você é um colaborador, as informações sobre como tratamos os seus dados pessoais se encontram disponíveis em nosso Aviso Interno de Privacidade.
                        </Typography>

                        <div className={classes.divider} />

                        {this.renderSection('1', 'O que você precisa saber antes de ler esse aviso?')}
                        <Typography className={classes.paragraph}><strong>Dados Pessoais</strong> são todas as informações que permitem a sua identificação de forma direta ou que tenham o potencial de o tornar identificável. Como por exemplo, seu nome, CPF, e-mail, profissão, dentre outras.</Typography>
                        <Typography className={classes.paragraph}><strong>Encarregado</strong> é a pessoa do nosso time responsável por cuidar da sua privacidade aqui na Bunzl. Se você tiver qualquer dúvida sobre como os seus dados são tratados por nós, é ele quem vai te ajudar.</Typography>
                        <Typography className={classes.paragraph}><strong>Tratamento de Dados Pessoais</strong> significa qualquer operação, como a coleta, utilização, acesso, reprodução, compartilhamento, armazenamento, eliminação, realizada com Dados Pessoais.</Typography>
                        <Typography className={classes.paragraph}>Toda vez que houver menção aos termos “Bunzl”, “nós” ou “nossos”, estamos nos referindo à Bunzl; de igual modo, toda vez que houver menção aos termos “você, “seu” ou “sua”, estamos nos referindo a você, Titular.</Typography>

                        {this.renderSection('2', 'Quem somos nós?')}
                        <Typography className={classes.paragraph}>Para os fins da Lei Geral de Proteção de Dados Pessoais (“LGPD”), a Bunzl é a Controladora dos Dados Pessoais para as atividades e dados constantes no presente Aviso. Isso significa que a Bunzl determina quais dados são coletados, como os dados serão utilizados e para quais finalidades.</Typography>
                        <Typography className={classes.paragraph}>As seguintes empresas estão incluídas no escopo desse Aviso de Privacidade:</Typography>
                        {this.renderList([
                            'Bunzl Equipamentos para Proteção Individual Ltda. – CNPJ: 43.854.777/0001-26',
                            'Labor Import Comercial Imp Exp Ltda. – CNPJ: 01.005.728/0001-79',
                            'DVS Equipamentos de Proteção Individual Ltda. – CNPJ: 07.439.329/0005-26',
                            'VCH – Importadora, Exportadora e Distribuição de Produtos Ltda. – CNPJ: 10.702.092/0001-05',
                            'Volk do Brasil Ltda. – CNPJ: 10.702.092/0006-10',
                            'DVT Comércio, Importação e Exportação Ltda. – CNPJ: 07.439.329/0001-00',
                            'Medcorp Hospitalar Ltda. – CNPJ: 67.630.541/0002-55',
                            'Dental Sorria Ltda. – CNPJ: 03.662.136/0001-55',
                            'B2B Web Distribuição de Produtos Ltda. – CNPJ: 19.812.763/0001-65',
                        ])}

                        {this.renderSection('3', 'Quais dados pessoais nós tratamos e para qual finalidade?')}
                        <Typography className={classes.paragraph}>Abaixo, apresentamos os principais Dados Pessoais que tratamos a seu respeito e os motivos.</Typography>

                        <div className={classes.calloutBlock}>
                            <Typography className={classes.subHeading} style={{ marginTop: 0 }}>Aquisição de Talentos</Typography>
                            <Typography className={classes.paragraph}>Nós, além de divulgarmos as nossas vagas em sites especializados, também recebemos currículos de indicações de nossos colaboradores, além dos currículos eventualmente deixados presencialmente em nossa sede. Nessas situações, nós iremos tratar seus Dados Pessoais para verificarmos as suas competências, currículo e atendimento aos requisitos específicos da vaga para a qual você se aplicou. Além disso, também iremos tratar seus Dados Pessoais para lhe enviar a carta oferta, nos casos nos quais desejarmos que você se torne um colaborador da Bunzl.</Typography>
                            <Typography className={classes.paragraph} style={{ marginBottom: 0 }}>Para essas atividades, os seguintes Dados Pessoais podem ser tratados: Nome Completo, RG, CPF, Nacionalidade, Endereço, CEP, Cidade, E-mail, Telefone, Telefone Celular, Formação, Histórico Escolar/Acadêmico, Idiomas, Qualificações e Certificações, Estado Civil, Data de Nascimento, Idade, Cargo, Empresa/Entidade/Organização, Expectativa Salarial, Remuneração, Data de Contratação, Endereço Profissional, Jornada de Trabalho e Foto.</Typography>
                        </div>

                        <div className={classes.calloutBlock}>
                            <Typography className={classes.subHeading} style={{ marginTop: 0 }}>Relações Comerciais – Clientes</Typography>
                            <Typography className={classes.paragraph}>Nós tratamos seus Dados Pessoais, enquanto cliente, para que seja possível viabilizarmos a relação comercial originada pelo contrato firmado com você, sua empresa, ou a empresa que você representa.</Typography>
                            <Typography className={classes.paragraph}>Para isso, podemos coletar e tratar os seguintes dados: Assinatura, Nome Completo, RG, CPF, Carteira de Motorista, Endereço, CEP, Cidade, Estado, País, Endereço Anterior, E-mail, Telefone, Telefone Celular, Usuário em Aplicativo de Mensagens, Histórico Escolar/Acadêmico, Qualificações e Certificações, Nome dos Pais/Responsáveis, Data de Nascimento, Histórico de Crédito, Dados Bancários (Banco, Agência e Número da conta), Dados de Cartão de Crédito, Declaração de IRPF, Extrato Bancário, Remuneração, Histórico de Pagamentos, Score de Crédito, Idade, E-mail Profissional, Empresa/Entidade/Organização, Endereço Profissional, Identificação Profissional, Profissão, Hábitos de Consumo, Histórico de Reclamações. Esses dados são utilizados para as seguintes finalidades:</Typography>
                            {this.renderList([
                                'Dar andamento em devoluções/trocas e averiguar reclamações de produtos e serviços;',
                                'Criar um cadastro em nossos sistemas com suas informações, facilitando e agilizando nosso relacionamento;',
                                'Efetuar os reembolsos ou estornos, por pagamento antecipado e compra não realizada, por devolução de valor referente material devolvido, ou por problema na venda efetuada;',
                                'Identificar e entregar as mercadorias adquiridas, mantendo você informado do status da entrega;',
                                'Realizar a análise de crédito, para garantir o recebimento das vendas a prazo com objetivo de proteção ao crédito;',
                                'Manter atualizados seus dados cadastrais em nossos sistemas;',
                                'Executar o contrato que você firmou conosco;',
                                'Manter o contato com você, prestando suporte e oferecendo nossos serviços conforme seu histórico de uso;',
                                'Realizar a cobrança de eventuais valores em aberto (vencidos) e não pagos; e',
                                'Verificar a existência e regularidade da empresa-cliente, para prosseguir com a venda dos produtos desejados.',
                            ])}
                        </div>

                        <div className={classes.calloutBlock}>
                            <Typography className={classes.subHeading} style={{ marginTop: 0 }}>Relações Comerciais – Fornecedores, Prestadores de Serviços e Parceiros</Typography>
                            <Typography className={classes.paragraph}>Nós podemos tratar seus Dados Pessoais para que seja possível viabilizarmos a relação comercial originada pelo contrato firmado com você, sua empresa, ou a empresa que você representa.</Typography>
                            <Typography className={classes.paragraph}>Para isso, podemos coletar os seguintes dados: Assinatura, CNPJ, Nome Completo, RG, CPF, Carteira de Motorista, Nacionalidade, Filiação, Data de Nascimento, Idade, Endereço, Estado, País, E-mail, Telefone, Telefone Celular, Usuário em Aplicativo de Mensagens, Cargo, Empresa/Entidade/Organização, Endereço Profissional, E-mail profissional, Dados de Treinamentos, Despesas Profissionais, Dados Bancários (Banco, Agência e Número da Conta), Extrato Bancário, Histórico de Crédito, Dados de Veículo, Histórico de Multas de Trânsito, e Perfil em Rede Social. Esses dados são utilizados para as seguintes finalidades:</Typography>
                            {this.renderList([
                                'Fazer uma avaliação minuciosa de nossos parceiros e fornecedores;',
                                'Firmar contratos e executá-los em sua integralidade, bem como outros adendos contratuais, como NDAs, termos de cessão, termos aditivos e termos de encerramento;',
                                'Prospectar, renovar ou sub-rogar contratos de parceiros;',
                                'Cadastrar parceiros em nossos sistemas de gestão e seus principais pontos de contato;',
                                'Efetuar o pagamento pelos serviços tomados e pelos produtos adquiridos;',
                                'Realizar um acompanhamento do serviço contratado/prestado durante o contrato vigente, inclusive mediante elaboração de atas de reunião para acompanhamento posterior e monitoramento de desempenho;',
                                'Gerir os contratos assinados vigentes;',
                                'Manter um canal de contato ativo com os fornecedores, prestadores de serviços e parceiros, inclusive para fins de convite para eventos e campanhas de incentivo da Bunzl; e',
                                'Permitir auditorias internas.',
                            ])}
                        </div>

                        <div className={classes.calloutBlock}>
                            <Typography className={classes.subHeading} style={{ marginTop: 0 }}>Obrigações Legais ou Regulatórias</Typography>
                            <Typography className={classes.paragraph}>Em algumas situações, somos obrigados a tratar alguns Dados Pessoais seus para assegurar o cumprimento com a legislação, como, por exemplo, para:</Typography>
                            {this.renderList([
                                'Assegurar a rastreabilidade do produto médico, utilizado nos seus atendimentos, perante a agência reguladora: Nome Completo, Carteira de Motorista, RG, CNPJ, CPF, Nacionalidade, E-mail, Telefone Celular, Usuário em Aplicativo de Mensagens, E-mail Profissional e Dado de Saúde do Produto a ser utilizado;',
                                'Emitir as Notas Fiscais/Notas Fiscais Eletrônicas: Nome completo, Razão Social, CPF, CNPJ, endereço e contato telefônico.',
                            ])}
                        </div>

                        <div className={classes.calloutBlock}>
                            <Typography className={classes.subHeading} style={{ marginTop: 0 }}>Cadastro na Academia Volk</Typography>
                            <Typography className={classes.paragraph}>
                                Quando você realizar o cadastro na plataforma <Link href="http://academia.volkdobrasil.com.br/cadastro" target="_blank" rel="noopener noreferrer">academia.volkdobrasil.com.br/cadastro</Link>, para ter acesso aos cursos e treinamentos da Volk do Brasil, nós iremos tratar alguns de seus Dados Pessoais, como Nome, E-mail, CPF, Data de Nascimento, Telefone, Empresa, Cargo, Segmento, Estado, Cidade.
                            </Typography>
                            <Typography className={classes.paragraph} style={{ marginBottom: 0 }}>Esses dados também serão utilizados para o envio de comunicação, contato comercial, retorno de dúvidas e sugestões, retorno ao fornecedor (que ofertou serviço ou produto) e retorno, quando você tiver enviado seu currículo para trabalhar conosco.</Typography>
                        </div>

                        <div className={classes.calloutBlock}>
                            <Typography className={classes.subHeading} style={{ marginTop: 0 }}>Procedimentos Internos</Typography>
                            <Typography className={classes.paragraph}>Para realizarmos nossas atividades regulares, como atividades financeiras e de contabilidade, marketing, prospecção de vendas e similares, precisamos tratar alguns Dados Pessoais seus, como: Nome Completo, Assinatura, CNPJ, RG, CPF, Número Interno de Registro, Nacionalidade, Endereço, CEP, Cidade, Estado, País, E-mail, Telefone, Telefone Celular, Data de Nascimento, Idade, Cargo, Empresa/Entidade/Organização, E-mail Profissional, Endereço Profissional, Função, Perfil em Rede Social, Dados do Veículo, Formação, Qualificações e Certificações, Experiência Profissional, Histórico Escolar/Acadêmico, Hábitos de Consumo, Tendências de Compra, Características de Navegação, Dados de Cookies, Histórico de Navegação, Histórico de Reclamações, Preferências de Entretenimento, Geolocalização, Histórico de Geolocalização, Histórico de Crédito, Score de Crédito, Dados Bancários (Banco, Agência e Número da Conta), Dados do Cartão de Crédito, Histórico de Pagamentos e Fotos.</Typography>
                            <Typography className={classes.paragraph}>Esses dados são utilizados para:</Typography>
                            {this.renderList([
                                'Construir e manter a base histórica de compras;',
                                'Manter registros de contas e outras transações comerciais e de pagamentos;',
                                'Analisar as categorias de compras para avaliar a composição das nossas atividades de compras;',
                                'Elaborar relatórios e análises internas, conforme necessário;',
                                'Gerar dados analíticos e estatísticos para monitorar e melhorar a performance de nosso site;',
                                'Garantir a segurança da operação de nosso site e sistemas internos;',
                                'Responder dúvidas e questionamentos da Diretoria;',
                                'Gerar leads e oportunidades de prospecção;',
                                'Enviar mailings com informações sobre nossos eventos e ações, e realizar as inscrições nos mesmos e;',
                                'Ajuizar ou recepcionar, cadastrar e gerir os processos judiciais;',
                                'Responder a consultas jurídicas internas das áreas da Bunzl.',
                            ])}
                        </div>

                        <Typography className={classes.subHeading}>Exercício regular de direitos</Typography>
                        <Typography className={classes.paragraph}>Podemos também tratar alguns de seus dados pessoais quando isto se fizer necessário para resguardarmos os nossos direitos.</Typography>

                        {this.renderSection('4', 'Com quem compartilhamos os seus dados pessoais?')}
                        <Typography className={classes.paragraph}>Nós podemos compartilhar os seus Dados Pessoais quando necessário para atingir a finalidade para a qual os dados foram coletados ou quando existir uma obrigação para realizar o compartilhamento. Essa transferência pode ocorrer entre empresas do mesmo grupo econômico, com consultorias, escritórios jurídicos externos, empresas fornecedoras e de suporte aos sistemas da Bunzl, órgãos públicos (como Receita Federal do Brasil), Poder Judiciário, parceiros de negócio, empresas de transporte, fornecedores, instituições de pagamento e instituições financeiras.</Typography>
                        <Typography className={classes.paragraph}>Para resguardar a sua privacidade, nos utilizamos de instrumentos contratuais para assegurar que os terceiros que recebam os seus Dados Pessoais em nosso nome confiram a eles a mesma proteção que nós.</Typography>
                        <Typography className={classes.paragraph}>Eventualmente, por sermos uma organização global, é possível que haja transferência dos seus Dados Pessoais para fora do Brasil, para que as empresas do nosso grupo em outros países nos auxiliem a conduzir nossos negócios, ou para fornecedores e parceiros comerciais localizados no exterior.</Typography>
                        <Typography className={classes.paragraph}>Nestes casos, nos certificaremos de que essa transferência ocorra apenas para os países que possuem um grau de segurança similar ao previsto pela legislação brasileira, ou quando a Autoridade Nacional de Proteção de Dados Pessoais assim autorizar.</Typography>
                        <Typography className={classes.paragraph}>Você pode ter mais informações sobre os terceiros com quem compartilhamos os seus dados por meio de requisição específica, conforme detalhado no item 6 abaixo.</Typography>

                        {this.renderSection('5', 'Quais são os seus direitos?')}
                        <Typography className={classes.paragraph}>Você, enquanto Titular de Dados Pessoais, possui os seguintes direitos:</Typography>
                        {this.renderList([
                            'Saber se realizamos algum Tratamento com seus Dados Pessoais e quais dados são tratados;',
                            'Corrigir ou solicitar a correção de dados incompletos, inexatos ou desatualizados;',
                            'Solicitar a anonimização, bloqueio ou eliminação de dados desnecessários ou excessivos em relação a finalidade para a qual foram coletados;',
                            'Solicitar a portabilidade dos dados a outro fornecedor de produtos ou serviços similares;',
                            'Obter informações sobre as entidades públicas ou privadas com as quais compartilhamos os seus dados;',
                            'Quando a atividade de Tratamento necessitar do seu consentimento, você pode se negar a consentir. Nesse caso, lhe informaremos sobre as consequências da não realização de tal atividade;',
                            'Quando a atividade de Tratamento estiver baseada do seu consentimento, você pode revogá-lo a qualquer momento.',
                        ])}
                        <div className={classes.calloutBlock}>
                            <Typography className={classes.paragraph} style={{ margin: 0 }}>
                                Para exercer os seus direitos, entre em contato com o nosso Encarregado, <strong>Ronaldo Ricioni</strong>, através do e-mail <Link href="mailto:encarregado@bunzl.com.br">encarregado@bunzl.com.br</Link>.
                            </Typography>
                        </div>

                        {this.renderSection('6', 'Cookies')}
                        <Typography className={classes.paragraph}>Cookie é um pequeno arquivo adicionado ao seu dispositivo ou computador para fornecer uma experiência personalizada de acesso. Os cookies ajudam a analisar o tráfico de internet e permitem saber quando você visitou um site específico. Mas fique tranquilo, pois um cookie não dá acesso a seu computador ou revela informações além daquelas que você escolhe compartilhar.</Typography>
                        <Typography className={classes.paragraph}>A Bunzl utiliza de cookies para diferentes finalidades, como gerar estatísticas de acesso, possibilitar que você navegue sem complicação e de forma ágil, e para lembrar as suas preferências de idioma. Abaixo listamos as categorias de cookies que utilizamos em nossas aplicações e suas respectivas finalidades:</Typography>

                        {this.renderCookieTable(
                            ['Tipo', 'O que faz'],
                            [
                                ['Necessários', 'São cookies essenciais para viabilizar o adequado funcionamento do nosso website, assim como para permitir que você faça uso de todas as funcionalidades disponíveis.'],
                                ['Desempenho', 'São cookies que nos ajudam a entender como os visitantes interagem com o nosso website, fornecendo informações sobre as áreas visitadas, o tempo de visita ao site e quaisquer problemas eventualmente encontrados.'],
                                ['Funcionais', 'São cookies que permitem que o nosso website se lembre das suas escolhas anteriores, como, por exemplo idioma de navegação. São responsáveis por proporcionar uma experiência personalizada.'],
                                ['Marketing', 'São cookies utilizados para fornecer mais conteúdo relevante e específico para o seu interesse. Podem, ainda, ser utilizados para apresentar publicidade com um maior direcionamento ou limitar o número que esta é veiculada. Também, permitem a medição da eficácia de uma campanha lançada.'],
                            ]
                        )}

                        <Typography className={classes.paragraph}>De modo geral, os cookies que utilizamos coletam as seguintes informações: qual navegador você utiliza, informações sobre o seu endereço IP, juntamente com a data, hora e duração da sua visita, as páginas visualizadas e os links nos quais você clica.</Typography>
                        <Typography className={classes.paragraph}>Você pode desabilitar os cookies nas configurações do seu navegador. Mas lembre-se que os cookies necessários são essenciais para o normal funcionamento do nosso website, de modo que a oposição à utilização deles poderá implicar na inutilização de sua experiência ou na suspensão de seu acesso.</Typography>

                        <Typography className={classes.subHeading}>Lista de cookies</Typography>
                        <Typography className={classes.paragraph}>Um cookie é um pequeno pedaço de dados (ficheiro de texto) que um site — quando visitado por um utilizador — pede ao seu navegador para armazenar no seu dispositivo, a fim de lembrar informações sobre si, tais como a sua preferência de idioma ou informações de login. Esses cookies são definidos por nós e são chamados de cookies primários. Também usamos cookies de terceiros — que são cookies de um domínio diferente do domínio do site que está a visitar — para as nossas iniciativas de publicidade e marketing.</Typography>

                        <Typography className={classes.paragraph}><strong>Cookies estritamente necessários</strong> — necessários para que o website funcione e não podem ser desligados nos nossos sistemas. Normalmente, só são configurados em resposta a ações levadas a cabo por si, como definir preferências de privacidade, iniciar sessão ou preencher formulários. Não armazenam qualquer informação pessoal identificável.</Typography>
                        {this.renderCookieTable(
                            ['Domínio', 'Cookies', 'Tipo'],
                            [['.mobsd.com.br', 'OptanonConsent, OptanonAlertBoxClosed', 'Próprio']]
                        )}

                        <Typography className={classes.paragraph}><strong>Cookies de desempenho</strong> — permitem contar visitas e fontes de tráfego, para medir e melhorar o desempenho do website. As informações recolhidas são agregadas e anónimas.</Typography>
                        {this.renderCookieTable(
                            ['Domínio', 'Cookies', 'Tipo'],
                            [['mobsd.com.br', '_gid, _gat_UA-, _ga', 'Próprio']]
                        )}

                        <Typography className={classes.paragraph}><strong>Cookies de publicidade</strong> — podem ser estabelecidos pelos nossos parceiros de publicidade, para construir um perfil sobre os seus interesses e mostrar anúncios relevantes em outros websites.</Typography>
                        {this.renderCookieTable(
                            ['Domínio', 'Cookies', 'Tipo'],
                            [['youtube.com', 'VISITOR_INFO1_LIVE, __Secure-YEC, CONSENT', 'Terceiro']]
                        )}

                        {this.renderSection('7', 'Por quanto tempo tratamos os seus dados pessoais?')}
                        <Typography className={classes.paragraph}>Reteremos seus dados pessoais pelo tempo que for necessário para cumprir a finalidade para a qual foram coletados, a menos que um período de retenção mais longo seja necessário para cumprir obrigações legais, resguardar nossos direitos ou cumprir acordos judiciais/extrajudiciais.</Typography>
                        <Typography className={classes.paragraph}>Para determinar o período de retenção de seus dados pessoais, nos baseamos nos seguintes critérios:</Typography>
                        {this.renderList([
                            'Se temos uma obrigação legal, contratual ou outra de reter dados pessoais, ou se são necessários para fins de investigação ou litígio;',
                            'Se são necessários para manter registros comerciais e financeiros precisos.',
                        ])}

                        {this.renderSection('8', 'Como mantemos os seus dados pessoais seguros?')}
                        <Typography className={classes.paragraph}>Nós adotamos políticas e procedimentos rigorosos que determinam como os dados pessoais devem ser tratados na Bunzl. Tais normas têm como objetivo garantir o tratamento adequado e em conformidade com as legislações aplicáveis de dados pessoais.</Typography>
                        <Typography className={classes.paragraph}>Adotamos, também, medidas técnicas aptas a manter os seus dados pessoais seguros e protegidos de acessos não autorizados e de situações acidentais ou ilícitas de destruição, perda, alteração, comunicação ou qualquer outra forma de tratamento inadequado ou ilícito, sempre à luz das regras aplicáveis de proteção de dados e segurança da informação.</Typography>
                        <Typography className={classes.paragraph}>Nossas medidas de segurança são continuamente monitoradas e revisadas de acordo com os avanços tecnológicos e recursos organizacionais.</Typography>

                        {this.renderSection('9', 'Dúvidas?')}
                        <Typography className={classes.paragraph}>Se tiver qualquer dúvida, você pode entrar em contato com o nosso Encarregado pelo tratamento de dados pessoais, por meio do e-mail <Link href="mailto:encarregado@bunzl.com.br">encarregado@bunzl.com.br</Link>.</Typography>

                        {this.renderSection('10', 'Atualização')}
                        <Typography className={classes.paragraph}>Pode ser que as informações aqui disponibilizadas sejam atualizadas ou alteradas, para refletir a realidade das nossas operações. Por isso, aconselhamos que você consulte esse Aviso periodicamente.</Typography>
                        <Typography className={classes.paragraph} style={{ marginBottom: 0 }}><em>Última Atualização: 02 de julho de 2026</em></Typography>

                    </Paper>
                </Container>

                <Box className={classes.footer}>
                    <Typography variant="body2">www.mobsd.com.br</Typography>
                    <Link href="#/" className={classes.footerBack}>Voltar para o login</Link>
                </Box>
            </div>
        )
    }
}

export default withStyles(styles)(PrivacyPolicyPage)
